import { TemplateService } from 'src/app/web-generator/template-generator/service/template.service';
import { Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AbstractIndexSection } from '../../abstract-index-section';
import { IndexArticle } from './index-article';
import { SECTION_DATA } from '../../service/section-data';
import { Section } from 'src/app/web-generator/template-generator/entity/section';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { CommonHttpClientService } from 'src/app/share/service/common-http-client.service';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { LockDirective } from 'src/app/share/directive/lock-until.directive';
import { MenuSub } from 'src/app/web-generator/template-generator/entity/menus';



export abstract class AbstractIndexArticle extends AbstractIndexSection<Array<IndexArticle>> implements OnInit {
  @ViewChild('dataSourceLock', {static: false}) dataSourceLock: LockDirective;
  belongSiteModules = ['NORMAL', 'SINGLE'];
  /** 資料來源選單選項 */
  dataSourceOptions: MenuSub[];

  constructor(
    @Inject(SECTION_DATA) protected section: Section,
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected serverConfigService: ServerConfigService,
    protected translate: TranslateService,
    protected http: CommonHttpClientService,
    protected templateService: TemplateService,
  ) {
    super(section, generatorEnv, platformId, serverConfigService, templateService, translate);
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.editable) {
      this.loadDatasourceOptions();
    }
    this.setMenuButtonLabel();
  }

  refreshRemoteData(args?: any[]) {
    const path = this.section.data.path;
    const moduleKey = this.section.data.moduleKey;

    if (path && moduleKey) {
      this.http.get<{total: number, rows: Array<IndexArticle>}>(`${this.generatorEnv.apiHost}/api/${this.translate.currentLang}/cm/${moduleKey.toLocaleLowerCase()}/${path}/indexArticle`, {
        params: {
          page: this.offset / this.limit,
          size: this.limit,
          sort: ['open_start_date,desc']
        }
      }).subscribe(data => {
        this.remoteData = data.rows;
        if (this.dataSourceLock) {
          this.dataSourceLock.unlock();
        }
      }, error => {
        this.remoteData = this.remoteDefaultData;
        if (this.dataSourceLock) {
          this.dataSourceLock.unlock();
        }
      });
    }
  }

  dataSourceChange(menuPath: string) {
    if (this.dataSourceLock.isLock) { return; }
    this.dataSourceLock.lock();
    const menu: MenuSub = this.dataSourceOptions.find(m => m.path === menuPath);
    if (!menu) {
      console.error(`select a none existing menu(${menuPath})`);
      this.remoteData = this.remoteDefaultData;
      this.section.data.menuLabel = '';
      this.data.menuButtonLabel = '';
      delete this.section.data.path;
      this.dataSourceLock.unlock();
      return;
    }

    if (menu.path) {
      this.section.data.path = menu.path;
      this.section.data.moduleKey = menu.moduleKey;
      this.refreshRemoteData();
      if (menu.title !== '') {
        this.section.data.menuLabel = menu.title;
      }
    } else {
      this.remoteData = this.remoteDefaultData;
      this.section.data.menuLabel = '';
      delete this.section.data.path;
      this.dataSourceLock.unlock();
    }

    this.setMenuButtonLabel();
  }

  setMenuButtonLabel() {
    this.translate.get('more', this.data).subscribe((res: string) => this.data.menuButtonLabel = res);
  }

  /** 載入資料來源選項 */
  loadDatasourceOptions() {
    this.templateService.getIndexDataSource(this.belongSiteModules).subscribe(opts => {
      this.dataSourceOptions = opts;
    });
  }
}
